import { INotificationReadRequest } from "../../repository/INotificationReadRequest";

export const setNotificationsRead = (payload: INotificationReadRequest) => ({
  type: "@saga/SET_NOTIFICATION_READ",
  payload,
});
